import React, { useEffect } from 'react';
import { useAuth } from '../components/context/AuthContext';
import { Page } from '../types';
import LoadingSpinner from '../components/LoadingSpinner';
import PageWrapper from '../components/PageWrapper';

interface SignupPageProps {
    navigateTo: (page: Page) => void;
    initialPrompt: string | null;
    startOnboarding: (prompt: string) => void;
    showNotification: (message: string, type: 'success' | 'error' | 'info') => void;
}

const SignupPage: React.FC<SignupPageProps> = ({ navigateTo, initialPrompt, startOnboarding }) => {
    const { signup, isAuthenticated, isLoading } = useAuth();

    useEffect(() => {
        if (isAuthenticated) {
             if (initialPrompt) {
                startOnboarding(initialPrompt);
            } else {
                navigateTo('dashboard');
            }
        }
    }, [isAuthenticated, navigateTo, initialPrompt, startOnboarding]);

    // Show a spinner while Auth0 is initializing or redirecting
    if (isLoading) {
        return <div className="pt-20 flex-grow flex items-center justify-center"><LoadingSpinner /></div>;
    }

    return (
        <PageWrapper>
            <div className="py-20 sm:py-32 flex-grow flex items-center justify-center">
                <div className="bg-[var(--panel-bg)] backdrop-blur-sm border border-[var(--border-color)] rounded-2xl p-8 md:p-12 w-full max-w-md text-center">
                    <h1 className="text-3xl font-extrabold text-[var(--text-primary)]">
                        Create Your Account
                    </h1>
                    <p className="mt-2 text-[var(--text-secondary)] mb-8">
                        Start building your dream app today.
                    </p>
                    <button 
                        onClick={() => signup()} 
                        className="w-full px-8 py-3 text-base font-semibold text-white bg-gradient-to-r from-[var(--gradient-from)] to-[var(--gradient-to)] rounded-md hover:opacity-90 transition-opacity"
                    >
                        Sign Up or Log In
                    </button>
                    <p className="text-center text-sm text-[var(--text-secondary)] mt-6">
                        By signing up, you agree to our{' '}
                        <button onClick={() => navigateTo('terms')} className="font-medium text-[var(--gradient-to)] hover:underline">
                            Terms of Service
                        </button>.
                    </p>
                </div>
            </div>
        </PageWrapper>
    );
};

export default SignupPage;